module.exports = __webpack_public_path__ + "static/media/dailyGraphNavMenu.2e7e9834.png";